import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reporte/reportecuentaspagar';
import ReporteCuentasPagar from './ReporteCuentasPagar';

const mstp = state => {
    return {
        ...state.reportecuentaspagar,
        permisos: state.login.me.permisos
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ReporteCuentasPagar)
